import React, { useState, useEffect } from 'react';
import HeadSub from '../../../../components/comm/HeadSub';
import AgreeConditionsBox from '../../../../components/box/AgreeConditionsBox';
import { useNavigate } from "react-router-dom";
import URL from "../../../../constants/url";
import style from './AgreeGuardian.module.css';

import { BottomSheet } from 'react-spring-bottom-sheet';
import 'react-spring-bottom-sheet/dist/style.css';

const AgreeGuardian = () => {

    const navigate = useNavigate();


    const [open, setOpen] = useState(false);
                
        useEffect(() => {
            setOpen(false);
        }, []);
    
        function onDismiss() {
            setOpen(false);
        }

    return (
        <>
            <HeadSub title="보호자 동의" />

            <div id="sub-content" data-layout="white">
                <div className='inner-wrap' data-padding="30">
                    <strong className={style['title']}>
                    만 14세 미만 사용자의 경우 <br />
                    보호자의 동의가 필요합니다
                    </strong>

                    <div className={style['top-box']}>
                    
                        <div className='chkbox-custom' data-chkbox='basic'>
                            <input type="checkbox" id='require-chk2'/>
                            <label htmlFor="require-chk2">
                                <div className={style['txt-box']}>
                                <b>&#91;필수&#93;</b> <p>개인정보 활용 동의</p>
                                </div>
                            </label>
                        </div>
                        
                        <button className={style['more-btn']} onClick={() => setOpen(true)}>
                            <span>보기</span>
                        </button>
                     
                    </div>

                    <div className={style['mid-box']}>
                        <button className={style['mobile']} onClick={() => navigate(URL.MOBILEIDENTITY)}>
                            <p>
                                <span>휴대폰</span>
                                <span>본인인증</span>
                            </p>
                        </button>
                        <button className={style['i-pin']}>
                            <p>
                                <span>아이핀</span>
                                <span>본인인증</span>
                            </p>
                        </button>
                    </div>


                    <BottomSheet

                        scrollLocking={false} // 내부 스크롤을 위해 BottomSheet 스크롤 잠금 해제
                        expandOnContentDrag={false} // 내용 드래그로 확장 방지

                        open={open}
                        onDismiss={onDismiss}  
                        snapPoints={({ maxHeight }) => [
                            maxHeight - maxHeight / 10,
                            maxHeight * 0.6,
                            ]}
                        blocking={true}
                        >
                        <AgreeConditionsBox onClose={onDismiss}/>
                    </BottomSheet>



                </div>
            </div>
            
        </>
    )
}

export default AgreeGuardian